
<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="24">
        <div>
          <div v-if="integrationWizardIndex >= 1">
            <h4 class="center-text">Azure Logs Configuration</h4>
            <el-steps :active="integrationWizardIndex" :finish-status="apiCall.error? 'error': 'success'">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item style="overflow: unset" :key="1">
              <h3>HOW TO CONNECT TO AZURE LOGS</h3>
              <p>
                Confluera helps to protect your data, accounts, and workloads from unauthorized access. Confluera data
                protection services provide threat detection that continuously monitors and protects your accounts and
                workload.<span class="text-btn" @click="loadDocumentation('page-partner-signals-aws-cloudtrail')"> Learn More </span>
              </p>

              <el-row type="flex" :gutter="24">
                <el-col :span="4">
                  <el-card shadow="hover" style="text-align: center;">
                    <span class="display-block">
                      <i class="integration-icon logo-azure-log-color" style="font-size: 5em;"></i>
                    </span>
                  </el-card>
                </el-col>
                <el-col :span="20">
                  <el-row>
                    <el-row>                      
                      <el-col :span="24">
<pre>Azure Monitor And Azure AD Logs Collect And Analyze Log Data From Various Azure 
Resources, Providing Centralized Logging, Analysis, And Monitoring 
Capabilities. By Integrating Azure Monitor And Azure AD Logs, Confluera Will Display 
Detections From The Last Month Based On Data Retrieved From Your 
Azure Account.</pre>
                      </el-col>
                      <el-col :span="20" class="p-10">
                        <el-row>
                          <el-row>
                            <el-col :span="23"><span class="bold">Step 1</span></el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="23">Create an EventHub.</el-col>
                          </el-row>
                        </el-row>
                        <br />
                        <el-row>
                          <el-row>
                            <el-col :span="23"><span class="bold">Step 2</span></el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="23">Export Azure Monitor Logs to the created EventHub.</el-col>
                          </el-row>
                        </el-row>
                        <br />
                        <el-row>
                          <el-row>
                            <el-col :span="23"><span class="bold">Step 3</span></el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="23">Export Azure AD Logs to the created EventHub</el-col>
                          </el-row>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-row>                                                 
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item :key="2">
              <div class="box flex center ">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-form-item label="Integration Name">
                    <el-input
                      v-model="integrationWizardData.nickName"
                      placeholder="Enter Name for your integration"
                      @keydown.native.space.prevent
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Event Hub Namespace">
                    <el-input v-model="integrationWizardData.eventHubNamespaceEndpoint" placeholder="Enter your Azure event hub namespace"></el-input>
                  </el-form-item>
                  <el-form-item label="Event Hub Name">
                    <el-input
                      v-model="integrationWizardData.eventHubName"
                      placeholder="Enter your event hub name"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Number of Partitions">
                    <el-input v-model="integrationWizardData.numPartitions" placeholder="Enter the number of partitions"></el-input>
                  </el-form-item>
                  <el-form-item label="Shared Access Key Name">
                    <el-input v-model="integrationWizardData.sharedAccessKeyName" placeholder="Enter your shared access key name"></el-input>
                  </el-form-item>
                  <el-form-item label="Shared Access Key">
                    <el-input v-model="integrationWizardData.sharedAccessKey" placeholder="Enter your shared access key"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="3" class="initiated mt-20">
              <h4 class="center-text">Initiated!</h4>
              <div class="box flex" v-loading="apiCall.outbound" element-loading-spinner="el-icon-loading"></div>
              <div class="box flex mt-20 mb-20">
                <p>
                  We are connecting your Azure Logs data.
                </p>
              </div>
              <div class="box flex mt-20">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">View Configured Account</el-button>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4" class="initiated error mt-20">
              <h4 class="center-text">Error!</h4>
              <div class="box flex">
                <span class="center-text error-icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              </div>
              <div class="box mt-20 mb-20 error-message">
                <p>
                  We could not connect to your Azure Logs account.
                </p>
                <p>
                  Troubleshoot to fix your configuration.
                </p>
                <div v-if="apiCall.error" class="box mt-20">
                  <p>
                    {{ apiCall.errorMsg.code }}:
                    {{ apiCall.errorMsg.message }}
                  </p>
                </div>
              </div>
              <div class="box flex mt-40">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">Troubleshoot / FAQs</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex float-right">
            <span
              v-if="integrationWizardIndex >= 1"
              class="text-underline cursor-pointer back-button"
              @click="backIntegrationStep"
            >
              Go Back
            </span>
            <el-button v-if="integrationWizardIndex < 1" size="medium" round @click="nextIntegrationStep">
              Set Up Azure Log
            </el-button>
            <el-button v-if="integrationWizardIndex == 1" size="medium" round @click="updateIntegrationSettings">
              Retrieve
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

import { AZURE_LOG_INTEGRATION_CONFIG_CREATE_REQUEST } from '@/store/modules/integrations/azure-log-integration.type'

export default {
  name: 'AzureLogIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      integrationLastStep: 3,
      apiDispatchState: AZURE_LOG_INTEGRATION_CONFIG_CREATE_REQUEST
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.integration-settings {
  overflow: unset;
}
.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}

.integration-icon {
  display: inline-block;
  height: 70px;
  width: 100%;
  background-size: 50%;
}

pre {
  background-color: white;
  margin: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/AzureLogIntegrationWorkflow.vue